module.exports = __webpack_public_path__ + "static/img/case_detail_03_4.be9bc3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_03_4.png
// module id = Tl30
// module chunks = 34